import { OnboardingModule } from '@delon/abc/onboarding';
import { ReuseTabModule } from '@delon/abc/reuse-tab';
import { SVModule } from '@delon/abc/sv';
import { DelonACLModule } from '@delon/acl';
export const SHARED_DELON_MODULES = [
  SVModule,
  DelonACLModule,
  OnboardingModule,
  ReuseTabModule
];
